module.exports = __webpack_public_path__ + "b1fd0d4cdc992bb49b729b9a842b5ad1.png";